import { Component, OnInit, ChangeDetectorRef, OnDestroy, inject } from '@angular/core';
import { Subscription, tap } from 'rxjs';

import { ByocEpisodeService } from '../../service/episode.service';
import { ByocService } from '../../../service/byoc.service';

import { FetchModel } from '../../../model/byoc.model';
import { control } from '../../../utils';

@Component({
    selector: 'app-byoc-episode-step-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
    standalone: false
})
export class ByocEpisodeStepLinkComponent implements OnInit, OnDestroy {
    private readonly byocEpisodeService = inject(ByocEpisodeService);
    private readonly byocService = inject(ByocService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly subscriptions = new Subscription();

    get control() {
        return control(this.byocEpisodeService.form.get('source')!.get('url'));
    }

    ngOnInit() {
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    cancelClick() {
        this.byocEpisodeService.close('btn-close');
    }

    nextClick() {
        if (this.byocEpisodeService.processing || this.control.invalid) {
            return;
        }

        this.byocEpisodeService.processing = true;
        this.changeDetectorRef.markForCheck();

        this.subscriptions.add(
            this.byocService
                .fetch(this.control.value)
                .pipe(
                    tap((fetch: FetchModel) => {
                        this.byocEpisodeService.info(fetch);
                        this.changeDetectorRef.markForCheck();
                    }),
                )
                .subscribe(),
        );
    }
}
